import { StatesSelectComponent } from 'app/shared/selects/states/states-select.component';
import { Component, OnInit, Input, NgZone, ViewChild } from '@angular/core';
import { LayoutService } from '../layout/layout.service';
import { ProgramDto, ProgramDeliveryInformationDto, ProgramShippingLocationDto, ProgramId, ShippingLocationDto } from 'app/client-core/dtos/programs.model';
import { ValidationMessage } from 'app/validation';
import { ProgramService } from 'app/client-core/services/program.service';
import { ApiResponse } from 'app/client-core/api-response-models';
import * as moment from 'moment'
import { Observable } from 'rxjs';
import { Tactic } from 'app/client-core/dtos/shipping-distribution.model';
import { ApiService } from 'app/client-core/api.service';
import { DropzoneComponent } from 'ngx-dropzone-wrapper';
import { BsModalService, TypeaheadMatch } from 'ngx-bootstrap';
import { Router } from '@angular/router';
import { AddressEditModalComponent } from '../components/address-edit/address-edit.modal.component';
import { CountriesTypeaheadComponent } from '../typeahead/typeaheads/countries-typeahead.component';

@Component({
  selector: 'app-addressbook-delivery-information',
  templateUrl: './addressbook-delivery-information.component.html',
  styleUrls: ['./addressbook-delivery-information.component.scss']
})
export class AddressBookDeliveryInformationComponent implements OnInit {
  @ViewChild('countryTypeahead') countryTypeahead: CountriesTypeaheadComponent;
  @ViewChild('stateSelect') stateSelect: StatesSelectComponent;
  @ViewChild(DropzoneComponent) drpzone: DropzoneComponent;
  @Input() ready: boolean;
  programDto: ProgramDto = new ProgramDto();
  validationMessages: ValidationMessage;
  programDeliveryInformationResponse: ApiResponse<ProgramDeliveryInformationDto>;
  programDeliveryInformationDto: ProgramDeliveryInformationDto = new ProgramDeliveryInformationDto();
  oldProgramDeliveryInformationDto: ProgramDeliveryInformationDto = new ProgramDeliveryInformationDto();
  @Input() canEdit: boolean;
  submitting: boolean;
  validated: boolean;
  @Input() changeReason: number;
  @Input() onlyHaveDownloadMethods: boolean;
  minDate: Date = moment()
    .add("days", 1)
    .toDate();
  itemObjectsLeft: ProgramShippingLocationDto[] = [];
  itemObjectsRight: ProgramShippingLocationDto[] = [];
  addressFilter: string;
  distributionDto: any;
  submitted: boolean;
  @Input() type: string;
  @Input() fromCampaigns = false;
  config;
  file: any;
  shippingLocationDto: ShippingLocationDto = { saveToAddressBook: true } as ShippingLocationDto;
  isValid: boolean = false;
  submited: boolean;
  @Input() shouldValidateDate: boolean;

  @Input() contactType: string;
  @Input() selectedRetailerId: number;
  @Input() shouldValidate: boolean;
  accountLocationId: any;
  createPlanModal: any;
  savingAddress: boolean;

  onAfterValidate(isValid: boolean): void {
    console.log('>>IsValid', isValid);
    this.submited = true;
    if (!isValid)
      return;

    this.onSubmitShipping();
  }

  validatorOptions = {
    //container: '#messages',
    message: "Field is invalid",
    feedbackIcons: {
      valid: 'fa fa-check',
      invalid: 'fa fa-times',
      validating: 'fa fa-refresh'
    },
    fields: {
      city: {
        validators: {
          notEmpty: {
            message: "City is required"
          }
        }
      },
      address1: {
        validators: {
          notEmpty: {
            message: "Address1 is required"
          }
        }
      },
      zip: {
        validators: {
          notEmpty: {
            message: "Zip is required"
          }
        }
      }
    }
  };

  constructor(
    private layoutService: LayoutService,
    private programService: ProgramService,
    private zone: NgZone,
    private apiService: ApiService,
    private router: Router,
    private modalService: BsModalService
  ) {
    const self = this;
    this.config = {
      autoProcessQueue: false,
      acceptedFiles: '.csv',
      uploadMultiple: false,
      maxFiles: 1,
      dictDefaultMessage: 'Click or drop files here',
      init: function () {
        this.on('addedfile', function (file) {
          self.zone.run(() => {
            console.log(file);
            self.file = file;
          });
        });
      }
    };
  }

  ngOnInit() {
    this.ready = true;
  }

  clear() {
    return new Promise((resolve, reject) => {
      this.ready = false;
      this.itemObjectsLeft = [];
      this.itemObjectsRight = [];
      this.programDto = new ProgramDto();
      this.programDeliveryInformationDto = new ProgramDeliveryInformationDto();
      this.minDate = moment().add('days', 1).toDate();
      this.shippingLocationDto = { saveToAddressBook: true } as ShippingLocationDto;
      this.distributionDto = {};
      this.changeReason = 0;
      this.type = '';
      resolve(true);
    })
  }

  onUploadSuccess() {

  }

  onUploadError() {

  }

  processUpload(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.apiService.uploadShippingLocations(
        this.file,
        0,
        null,
        '',
        true
      ).subscribe(data => {
        const response = (data as any)
        try {
          if (!response.body.hasError) {
            this.drpzone.directiveRef.dropzone().removeAllFiles();
            this.validationMessages = new ValidationMessage(null, true, 'Upload Complete', 'success', 10);
            this.programService.shippingLocationUpdated.next();
            this.close();
          } else {
            this.drpzone.directiveRef.dropzone().removeAllFiles();
            // tslint:disable-next-line:max-line-length
            let errorString = 'One or more entries where unable to be imported due to data provided in the following fields <br>';
            errorString += response.body.errorMessage;
            errorString = errorString.replace(/\n/g, '<br>')
            this.validationMessages = new ValidationMessage(null, true, errorString, errorString, 30).isDanger();
            resolve();
          }
        } catch (error) {
          this.drpzone.directiveRef.dropzone().removeAllFiles();
          resolve();
        }
      }, error => {
        resolve();
      });
    })
  }

  init() {

  }

  closeModal() {
    this.layoutService.hideSideModal.next();
  }

  shouldSaveInfo() {
    if (this.programDeliveryInformationDto.deliveryDate != this.oldProgramDeliveryInformationDto.deliveryDate) {
      return true;
    }

    if (this.programDeliveryInformationDto.deliveryNotes != this.oldProgramDeliveryInformationDto.deliveryNotes) {
      return true;
    }
    return false;
  }

  isDeliveryAddressValid() {
    if (!this.programDeliveryInformationDto.programShippingLocation) {
      return false;
    }

    const validAddresses = this.programDeliveryInformationDto.programShippingLocation.filter(
      a => !a.markedForDeletion
    ).length;
    return validAddresses > 0;
  }

  showDeliveryAddressErroMessages() {
    return !this.isDeliveryAddressValid() && this.validated;
  }

  canSaveDeliveryInformation() {
    return this.isDeliveryAddressValid() && this.isDeliveryDateValid();
  }

  isDeliveryDateValid() {
    return (
      this.programDeliveryInformationDto.deliveryDate != null &&
      this.isFutureDate()
    );
  }

  isFutureDate() {
    if (!this.canEdit || this.fromCampaigns) {
      return true;
    }
    if (this.onlyHaveDownloadMethods) {
      return true;
    }
    if (
      !this.programDeliveryInformationDto ||
      !this.programDeliveryInformationDto.deliveryDate
    ) {
      return false;
    }

    const minDate = moment(this.minDate.toISOString());
    const choosedDate = moment(
      this.programDeliveryInformationDto.deliveryDate.toISOString()
    );
    return moment(choosedDate.format("MM/DD/YYYY")).isSameOrAfter(
      minDate.format("MM/DD/YYYY")
    );
  }

  validateFields(): boolean {
    if (this.shouldValidate && ((!this.isDeliveryAddressValid() || !this.isDeliveryDateValid()) && !this.onlyHaveDownloadMethods)) {
      this.validationMessages = new ValidationMessage(
        null,
        true,
        "Delivery Information could not be saved"
      );
      return false;
    }
    return true;
  }

  downloadTemplate(): void {
    this.programService.getTemplate();
  }

  onStatesTypeaheadSelected($event: TypeaheadMatch): void {
    if ($event && $event.item.stateCode)
      this.shippingLocationDto.state = $event.item.stateCode;
  }

  onCountriesTypeaheadSelected($event: TypeaheadMatch): void {
    if ($event && $event.item.id)
      this.shippingLocationDto.country = $event.item.countryCode;
  }

  onStateSelected($event) {
    console.log('onStateSelected', $event);
    this.shippingLocationDto.state = $event;
  }

  onSubmitShipping(): Promise<void> {
    if (this.savingAddress) {
      return;
    }
    this.savingAddress = true;
    return new Promise((resolve, reject) => {
      this.submitted = false;

      if (!this.canSubmitShippingLocation()) {
        this.submitted = true;
        this.validationMessages = new ValidationMessage(null, true, "there are some validation errors.");
        this.savingAddress = false;
        reject()
        return;
      }

      let observe: Observable<ApiResponse<any>>;
      observe = this.programService.createProgramShippingLocation(this.shippingLocationDto);
      observe.subscribe(res => {
        if (!res.hasError) {
          this.validationMessages = new ValidationMessage(null, true, "New shipping location added").isSuccess();
          this.shippingLocationDto = {} as ShippingLocationDto;
          this.countryTypeahead.cleartext();
          this.stateSelect.selectedValue = undefined;
          this.programService.shippingLocationUpdated.next();
          this.savingAddress = false;
          this.close();
          resolve();
        } else {
          this.savingAddress = false;
          this.validationMessages = new ValidationMessage(res.error, true, "shipping location not be saved");
          reject();
        }
      },
        (err: any) => {
          this.validationMessages = new ValidationMessage(null, true, "Unexpected error occured");
          this.savingAddress = false;
          reject();
        },
        () => {
        });
    })
  }

  close() {
    this.layoutService.hideSideModal.next();
  }

  isCountryValid() {
    return this.shippingLocationDto.country != null && this.shippingLocationDto.country !== undefined;
  }

  isStateValid() {
    console.log(this.shippingLocationDto.state)
    return this.shippingLocationDto.state != null && this.shippingLocationDto.state !== undefined;
  }

  canSubmitShippingLocation() {
    return this.isCountryValid() &&
      this.isStateValid() &&
      this.isFutureDate();
  }

  private createPlanModalConfig = {
    animated: true,
    keyboard: false,
    backdrop: true,
    ignoreBackdropClick: true,
    class: "modal-lg"
  };
  openAddressEdit(location) {
    const initialState = { selectedId: location.deliveryLocationId }
    // tslint:disable-next-line:max-line-length
    this.createPlanModal = this.modalService.show(AddressEditModalComponent, Object.assign({}, this.createPlanModalConfig, { initialState }));
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/addressbook-delivery-information/addressbook-delivery-information.component.ts